import React from "react";

function Spinner() {
  return (
    <div className="spinner">
      <img
        src="https://ik.imagekit.io/hg5ihbggxrw/spinner_763xisum0.gif"
        alt="spinner"
      />
    </div>
  );
}

export default Spinner;
